module.exports = __webpack_public_path__ + "img/giordano-patrimoine.c847af24.svg";